<template>
  <div class="progress-circle"
       :style="{ '--dynamic-mask': `url(${mask})` }"
       @click="togglePlay">
<!--    <svg class="progress-ring" viewBox="0 0 50 50">-->
<!--      &lt;!&ndash; 背景圆环 &ndash;&gt;-->
<!--      <circle-->
<!--          class="progress-ring-bg"-->
<!--          cx="25"-->
<!--          cy="25"-->
<!--          r="20"-->
<!--          fill="transparent"-->
<!--          stroke="#86868b"-->
<!--          stroke-width="4"-->
<!--      />-->
<!--      &lt;!&ndash; 进度圆环 &ndash;&gt;-->
<!--      <circle-->
<!--          class="progress-ring-circle"-->
<!--          :class="{ 'smooth-progress': shouldAnimate }"-->
<!--          cx="25"-->
<!--          cy="25"-->
<!--          r="20"-->
<!--          fill="transparent"-->
<!--          stroke="#ffffff"-->
<!--          stroke-width="4"-->
<!--          stroke-linecap="round"-->
<!--          :stroke-dasharray="circumference"-->
<!--          :stroke-dashoffset="strokeDashoffset"-->
<!--          transform="rotate(-90 25 25)"-->
<!--      />-->
<!--    </svg>-->

<!--    &lt;!&ndash; 播放/暂停图标 &ndash;&gt;-->
<!--    <div class="play-pause-icon" :class="{ 'playing': isPlaying }" @click="togglePlay">-->
<!--      <svg t="1765788834509" class="play" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1922" width="200" height="200"><path d="M943.17747365 434.657683C763.37013265 297.433771 583.56279165 160.20986 403.77712465 22.964274 339.74122565-25.888544 247.47953565 19.758235 247.47953565 100.306592v823.38501c0 80.548357 92.26169 126.196941 156.297589 77.322449 179.785667-137.225717 359.593008-274.447822 539.400349-411.691602 51.01125-38.933061 51.01125-115.711837 0-154.664766z" fill="#ffffff" p-id="1923"></path></svg>-->
<!--      <svg t="1765788862717" class="pause" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2124" width="200" height="200"><path d="M358.40298 959.996726V64.001468C358.40298 28.652009 329.750971 0 294.401513 0c-35.349459 0-64.003274 28.652009-64.003274 64.001468v895.995258c0 35.338621 28.652009 64.003274 64.003274 64.003274 35.349459 0 64.001468-28.662846 64.001467-64.003274zM793.599955 959.996726V64.001468C793.599955 28.652009 764.947946 0 729.598487 0c-35.335009 0-63.988824 28.652009-63.988824 64.001468v895.995258c0 35.338621 28.652009 64.003274 63.988824 64.003274 35.349459 0 64.001468-28.662846 64.001468-64.003274z" fill="#ffffff" p-id="2125"></path></svg>-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  props: {
    progress: {
      type: Number | String,
      default: 0
    },
    isPlaying: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number | String,
      default: 0
    }
  },
  data() {
    return {
      previousProgress: 0,
      mask: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNiAzNiI+PHBhdGggZD0iTTE0IDIyLjU4N3YtOS4xNjhjMC0uOTM0LjU2My0xLjQyNSAxLjI2LTEuNDI1LjM4NiAwIC42MjcuMDY1Ljk2Ny4yNzNsNy40NjggNC40MDNjLjY2Mi4zOSAxLjAyLjcwNyAxLjAyIDEuMzI0IDAgLjYxOC0uMzU4LjkzNS0xLjAyIDEuMzI1bC03LjQ2OCA0LjQwM2MtLjM0LjIwOC0uNTgxLjI3My0uOTY2LjI3My0uNjk4IDAtMS4yNjEtLjQ3My0xLjI2MS0xLjQwOCIvPjwvc3ZnPg==',
    };
  },
  methods:{
    togglePlay(){
      this.$emit('togglePlay', this.index)
    },
  },
  computed: {

    circumference() {
      return 2 * Math.PI * 20;
    },
    strokeDashoffset() {
      return this.circumference - (this.progress / 100) * this.circumference;
    },
    shouldAnimate() {
      return this.progress >= this.previousProgress;
    }
  },
  watch: {
    progress(newVal, oldVal) {
      this.previousProgress = oldVal;
    },
    isPlaying(newVal, oldVal){
      if(oldVal){
        this.mask = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNiAzNiI+PHBhdGggZD0iTTE0IDIyLjU4N3YtOS4xNjhjMC0uOTM0LjU2My0xLjQyNSAxLjI2LTEuNDI1LjM4NiAwIC42MjcuMDY1Ljk2Ny4yNzNsNy40NjggNC40MDNjLjY2Mi4zOSAxLjAyLjcwNyAxLjAyIDEuMzI0IDAgLjYxOC0uMzU4LjkzNS0xLjAyIDEuMzI1bC03LjQ2OCA0LjQwM2MtLjM0LjIwOC0uNTgxLjI3My0uOTY2LjI3My0uNjk4IDAtMS4yNjEtLjQ3My0xLjI2MS0xLjQwOCIvPjwvc3ZnPg=='
      }else {
        this.mask = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNiAzNiI+PHBhdGggZD0iTTIzLjUgMTIuODkzdjEwLjIxNGMwIC43NjktLjU5NyAxLjM5My0xLjMzMyAxLjM5M2gtMS4zMzRjLS43MzYgMC0xLjMzMy0uNjI0LTEuMzMzLTEuMzkzVjEyLjg5M2MwLS43Ny41OTctMS4zOTMgMS4zMzMtMS4zOTNoMS4zMzRjLjczNiAwIDEuMzMzLjYyNCAxLjMzMyAxLjM5M3pNMTUuMTY3IDExLjVoLTEuMzM0Yy0uNzM2IDAtMS4zMzMuNjI0LTEuMzMzIDEuMzkzdjEwLjIxNGMwIC43NjkuNTk3IDEuMzkzIDEuMzMzIDEuMzkzaDEuMzM0Yy43MzYgMCAxLjMzMy0uNjI0IDEuMzMzLTEuMzkzVjEyLjg5M2MwLS43Ny0uNTk3LTEuMzkzLTEuMzMzLTEuMzkzeiIvPjwvc3ZnPg=='
      }
    }
  }
};
</script>

<style scoped>
.progress-circle {
  position: relative;
  width: 100px;
  height: 100px;
  background-color: rgba(255,255,255,0.6);
  border-radius: 50%;
  cursor: pointer;
}

.progress-circle::after {
  content: "";
  mask: var(--dynamic-mask);;
  mask-size: cover;
  display: inline-block;
  width: 100px;
  height: 100px;
  position: absolute;
  background-color: #000;
}

.progress-ring {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.progress-ring-circle {
  transition: none;
}

.progress-ring-circle.smooth-progress {
  transition: stroke-dashoffset 0.3s linear;
}

/* 播放/暂停图标样式 */
.play-pause-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  transition: opacity 0.3s ease;
  z-index: 1;
  cursor: pointer;
}

.play-pause-icon svg {
  width: 20px;
  height: 20px;
  display: none;
  transition: opacity 0.3s ease;
  top: 20px;
  left: 20px;
}

.play-pause-icon .play {
  display: block;
}

.play-pause-icon .pause {
  display: none;
}

.playing .play {
  display: none;
}

.playing .pause {
  display: block;
}
</style>
